import { Amazon, Blockquote, VocabularyFooter } from '../../../../src/components/blog';
import { VocabularySeriesHug } from '../../../../src/components/blog/vocabularySeries';
import * as React from 'react';
export default {
  Amazon,
  Blockquote,
  VocabularyFooter,
  VocabularySeriesHug,
  React
};